/**
 * Work order & service notes.
 *
 * Extracted verbatim from workOrdersService.ts — functions are invoked with
 * `this` bound to the WorkOrdersService instance (WorkOrdersCtx).
 */
import { HttpError } from '../api';
import { extractItems } from '../../utils/apiHelpers';
// Notes API
export async function listNotes(workOrderId, serviceId) {
    try {
        const path = serviceId ? `/work-orders/${workOrderId}/services/${serviceId}/notes` : `/work-orders/${workOrderId}/notes`;
        const response = await this.client.get(path);
        if (!response.success || !response.data) {
            return this.listFailure(response.error || 'Failed to list notes');
        }
        return extractItems(response.data, ['notes']);
    }
    catch (error) {
        console.error('[WorkOrdersService] List notes error:', error);
        return this.listFailure('Failed to list notes', error);
    }
}
export async function createNote(workOrderId, body) {
    try {
        const path = body.service_id ? `/work-orders/${workOrderId}/services/${body.service_id}/notes` : `/work-orders/${workOrderId}/notes`;
        // Don't send service_id in the body for the service endpoint (it's in the URL)
        const payload = body.service_id
            ? {
                description: body.description,
                actionable: body.actionable,
                show_on_invoice: body.show_on_invoice,
                completed_at: body.completed_at,
            }
            : body;
        const response = await this.client.post(path, payload);
        if (!response.success || !response.data) {
            // HttpError carries status so the background upload queue can
            // skip retries on permanent 4xx (e.g. WO closed → 409).
            throw new HttpError(response.status ?? 0, response.error || 'Failed to create note', response.errorBody);
        }
        return response.data.note || response.data;
    }
    catch (error) {
        console.error('[WorkOrdersService] Create note error:', error);
        throw error;
    }
}
export async function updateNote(workOrderId, noteId, body, serviceId) {
    try {
        const path = serviceId
            ? `/work-orders/${workOrderId}/services/${serviceId}/notes/${noteId}`
            : `/work-orders/${workOrderId}/notes/${noteId}`;
        const response = await this.client.put(path, body);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to update note');
        }
        return response.data.note || response.data;
    }
    catch (error) {
        console.error('[WorkOrdersService] Update note error:', error);
        throw error;
    }
}
export async function deleteNote(workOrderId, noteId, serviceId) {
    try {
        const path = serviceId
            ? `/work-orders/${workOrderId}/services/${serviceId}/notes/${noteId}`
            : `/work-orders/${workOrderId}/notes/${noteId}`;
        const response = await this.client.delete(path);
        if (!response.success) {
            throw new Error(response.error || 'Failed to delete note');
        }
    }
    catch (error) {
        console.error('[WorkOrdersService] Delete note error:', error);
        throw error;
    }
}
export async function completeNote(workOrderId, noteId, serviceId) {
    try {
        const path = serviceId
            ? `/work-orders/${workOrderId}/services/${serviceId}/notes/${noteId}/complete`
            : `/work-orders/${workOrderId}/notes/${noteId}/complete`;
        const response = await this.client.post(path, {});
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to complete note');
        }
        return response.data.note || response.data;
    }
    catch (error) {
        console.error('[WorkOrdersService] Complete note error:', error);
        throw error;
    }
}
export async function uncompleteNote(workOrderId, noteId, serviceId) {
    try {
        const path = serviceId
            ? `/work-orders/${workOrderId}/services/${serviceId}/notes/${noteId}/uncomplete`
            : `/work-orders/${workOrderId}/notes/${noteId}/uncomplete`;
        const response = await this.client.post(path, {});
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to uncomplete note');
        }
        return response.data.note || response.data;
    }
    catch (error) {
        console.error('[WorkOrdersService] Uncomplete note error:', error);
        throw error;
    }
}
